import React, { Component } from 'react';
import { DropdownContext } from './DropdownContext';
class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.getContainer = () => {
            return this._containerRef.current;
        };
        this.toggle = (e) => {
            const { disabled } = this.props;
            const { isOpen } = this.state;
            if (disabled) {
                return e && e.preventDefault();
            }
            this.setState({ isOpen: !isOpen });
        };
        this.getContextValue = () => {
            const { direction, disabled, id } = this.props;
            const { isOpen } = this.state;
            return {
                toggle: this.toggle,
                isOpen: isOpen,
                direction: direction ? direction : 'right-start',
                disabled: disabled,
                containerRef: this._containerRef,
                id: id,
            };
        };
        this._containerRef = React.createRef();
        this.state = {
            isOpen: false,
        };
    }
    componentDidMount() {
        this.getContainer();
    }
    render() {
        const { children } = this.props;
        return (React.createElement(DropdownContext.Provider, { value: this.getContextValue() },
            React.createElement("div", { ref: this._containerRef, className: 'ac-dropdown' }, children)));
    }
}
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map